'use client';

import Link from 'next/link';
import { ReactNode } from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import { Button } from '@/primitives';
import { APP_ROUTE_PATHS, PUBLIC_ROUTES } from '@/configs/routes';
import { useAdminGuard } from '@/hooks/useAdminGuard';

type RegistryCtaButtonProps = {
  children: ReactNode;
  sx?: SxProps<Theme>;
  variant?: 'contained' | 'outlined' | 'text';
};

/**
 * Wraps the "Registry" CTA so `useAdminGuard` (which calls `useSession()`)
 * only re-renders this button when auth resolves — not the whole hero. The
 * link still navigates to the public registry landing for unauth users; the
 * guard upgrades the destination for admins post-click.
 */
export function RegistryCtaButton({
  children,
  sx,
  variant = 'outlined',
}: RegistryCtaButtonProps) {
  const { handleClickLink } = useAdminGuard(APP_ROUTE_PATHS.DASHBOARD);
  return (
    <Button
      component={Link}
      href={PUBLIC_ROUTES.REGISTRY_LANDING}
      size="large"
      sx={sx}
      variant={variant}
      onClick={handleClickLink}
    >
      {children}
    </Button>
  );
}
